import * as React from 'react';
import { DemoItem } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';

export default function DatePickers({ value, onChange, sx = {}, style = {} }) {
  const [cleared, setCleared] = React.useState(false);

  React.useEffect(() => {
    if (cleared) {
      const timeout = setTimeout(() => {
        setCleared(false);
      }, 1500);

      return () => clearTimeout(timeout);
    }
  }, [cleared]);

  const handleClear = () => {
    setCleared(true);
    onChange(null); // ล้างค่า
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      {/* <Box
        sx={{
          width: '100%',
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          position: 'relative',
        }}
      > */}
        {/* <DemoItem label="DatePicker"> */}
          <DatePicker label="เลือกวันที่*"
            value={value}
            onChange={onChange}
            sx={{ sx }}
            slotProps={{
              field: { clearable: true, onClear: handleClear },
              textField: { size: 'small',placeholder: 'Select DD/MM/YYYY'},
            }}
            style={style}
          />
        {/* </DemoItem> */}

        {cleared && (
          <Alert
            sx={{ position: 'absolute', bottom: 0, right: 0 }}
            severity="success"
          >
          เคลียร์ค่าแล้ว
          </Alert>
        )}
      {/* </Box> */}
    </LocalizationProvider>
  );
}
